import { EllipsisVerticalIcon } from 'lucide-react'
import { Group, Panel } from 'react-resizable-panels'

import { UrlParam } from '@/lib/url/url-param.hook'

import { EXTRA_EXTRA_SMALL_DRAWER_WIDTH } from '@/pages/drawers/size'

import { BreadcrumbsProps } from '@/components/lemmala-design-system/breadcrumbs/breadcrumbs'
import {
  DropdownMenu,
  type DropdownMenuActionItem,
} from '@/components/lemmala-design-system/dropdown/dropdown-menu'
import { DrillInPageLayout } from '@/components/lemmala-design-system/layouts/drill-in-page-layout/drill-in-page-layout'
import { HorizontalTabs, type TabItem } from '@/components/lemmala-design-system/tabs'

type TabbedPageLayoutProps = {
  breadcrumbs: BreadcrumbsProps['items']
  onBreadcrumbItemClick?: BreadcrumbsProps['onItemClick']
  tabItems: TabItem[]
  onTabChange?: (tab: string) => void
  menuItems?: DropdownMenuActionItem[]
  // The name of the URL parameter that contains the active tab
  tabUrlParamName?: UrlParam
  rightSideContent?: React.ReactNode
  menuTriggerContent?: React.ReactNode
  additionalActions?: React.ReactNode
}

export const TabbedPageLayout = ({
  breadcrumbs,
  onBreadcrumbItemClick,
  tabItems,
  onTabChange,
  menuItems,
  tabUrlParamName,
  rightSideContent,
  menuTriggerContent,
  additionalActions,
}: TabbedPageLayoutProps) => {
  const menu = menuItems && (
    <DropdownMenu
      variant='secondary'
      triggerAppearance='headless'
      triggerContent={menuTriggerContent || <EllipsisVerticalIcon className='size-4' />}
      menuItems={menuItems}
    />
  )
  const actions =
    additionalActions || menu ? (
      <>
        {additionalActions}
        {menu}
      </>
    ) : undefined

  return (
    <DrillInPageLayout
      breadcrumbs={breadcrumbs}
      onBreadcrumbItemClick={onBreadcrumbItemClick}
      additionalActions={actions}
    >
      <Group orientation='horizontal' className='flex min-h-0 flex-1 bg-main-background-muted'>
        <Panel minSize={0}>
          <div className='flex h-full min-h-0 flex-col overflow-hidden bg-main-background-muted'>
            <HorizontalTabs
              urlParamKey={tabUrlParamName}
              onChange={onTabChange}
              variant='secondary'
              items={tabItems}
              labelAsTitle
              className='border-b border-main-border-default'
              contentClassName='min-h-0 overflow-auto'
            />
          </div>
        </Panel>

        {rightSideContent && (
          <Panel defaultSize={EXTRA_EXTRA_SMALL_DRAWER_WIDTH} minSize={250} maxSize={600}>
            <div className='h-full overflow-auto border-l border-main-border-default bg-main-background-muted'>
              {rightSideContent}
            </div>
          </Panel>
        )}
      </Group>
    </DrillInPageLayout>
  )
}
